<template>
  <Modal :show="show" style="border-radius: 0.32rem" @update:show="(val: boolean) => emit('update:show', val)"
    position="center" widthFitContent>
    <div class="create-wrapper">
      <div class="neck">
        <Button size="large" type="primary" class="btn" @click="handleClick">
          立即前往
        <i class="icon" />
        </Button>
      </div>
      <img class="neck-text"
        src="https://p4-ky.wsukwai.com/udata/pkg/KMOVIE-CDN/image/guideTop.png" />

      <div class="divider"></div>
      <div class="body">
        <img class="neck-text"
          src="https://p4-ky.wsukwai.com/udata/pkg/KMOVIE-CDN/image/guideBottom.png" />
      </div>
      <!-- <Button size="large" type="default" @click="emit('update:show', false)">我知道了</Button> -->
    </div>
  </Modal>
</template>
<script setup lang="ts">
import { ApiModal } from "#imports";
import checkPermission from "../checkPermission";
import { KLING_HOME_CREATE } from "../constants";
import Button from "./../common/button.vue";
import Modal from "./../common/modal.vue";
import ToastModal from "./toastModal.vue";
import kylogger from "@ky/sdk/dist/log/kylogger";

interface Props {
  show?: boolean;
}

type Event = {
  (e: "update:show", show: boolean): void;
};

defineProps<Props>();
const emit = defineEmits<Event>();
const toastModal = ref<ApiModal<typeof ToastModal>>();

const handleClick = () => {
  kylogger.collect("CLICK", "GOTO_NOW", {});
  checkPermission().then(() => {
    window.open(KLING_HOME_CREATE);
  });
};

onMounted(() => {
  toastModal.value = new ApiModal(ToastModal);
});
</script>
<style lang="less" scoped>
.create-wrapper {
  width: 18.16rem;
  padding: 0.8rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: rgba(26, 27, 34, 1);

  .neck {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    .btn {
      position: absolute;
      top: 5rem;
      right: 0.7rem;
      height: 0.8rem;
      padding: 0 0.3rem 0 0.52rem;
      font-weight: 500;
      font-size: 0.28rem;
      line-height: 0.48rem;
    }

    .icon {
      display: inline-flex;
      width: 0.64rem;
      height: 0.64rem;
      background-image: url(https://p4-ky.wsukwai.com/udata/pkg/kmovie/common-figma-plugin/417c61e7-12a9-4a92-845f-315c455300ea.png);
      background-size: 100% 100%;
    }
  }

  .neck-text {
    width: 100%;
    margin-top: 0.24rem;
  }

  .divider {
    width: 100%;
    margin: 0.48rem 0;
    height: 0.01rem;
    opacity: 0.4;
    background: linear-gradient(90deg,
        #ffffff 0%,
        #ffffff 20%,
        #b6ffe0 60%,
        #81d2ff 70%,
        #b7a5ff 80%,
        #b7a5ff 100%);
  }

  .body {
    width: 100%;
    display: flex;
    margin-bottom: 0.5rem;
  }
}
</style>
